import React from 'react';
import { ProgressIndicator } from '../ProgressIndicator/ProgressIndicator';
import './BlockUi.scss';
import { IOverlayProps } from './types';

/**
 * Renders a blurred overlay with ProgressIndicator on top.
 * It must be rendered into existing stacking context:
 * either element with "position" css property specified, or
 * body.
 */
export const Overlay = (props: IOverlayProps) => {
  const style = props.zIndex ? { zIndex: props.zIndex } : undefined;
  return (
    <div
      className={`hlc-blockui`}
      tabIndex={0}
      style={style}
      ref={props.setRef}
    >
      <div className={'hlc-blockui-overlay'} />
      <ProgressIndicator />
    </div>
  );
};

export default Overlay;
